export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9786.84db2e26.jpg";